import Vue from 'vue'
import Vuex from 'vuex'
import { getSession, setSession, delSession } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuList: getSession('communityMenu') ? JSON.parse(getSession('communityMenu')) : [],
    token: getSession('communityToken'),
    userInfo: getSession('communityUser') ? JSON.parse(getSession('communityUser')) : {},
    options: [],
    activeIndex: 0,
    refreshPath:'',
    sendList: getSession('sendList') ? JSON.parse(getSession('sendList')) : [],
    communityInfo: getSession('communityInfo') ? JSON.parse(getSession('communityInfo')) : {},
  },
  mutations: {
    // 将路由存入vuex和session中
    SET_ROUTERS: (state, routers) => {
      setSession('communityMenu', JSON.stringify(routers));
      state.menuList = routers;
    },
    // 将token存入vuex和session中
    SET_TOKEN(state, token) {
      if (token) {
        setSession('communityToken', token);
        state.token = token
      } else if (token == null) {
        delSession('communityToken');
        state.token = null
      }
    },
    // 将用户信息存入vuex和session中
    SET_USER(state, user) {
      state.userInfo = user;
      setSession('communityUser', JSON.stringify(user));
    },
    DEL_TOKEN(state) {
      state.options = [];
      delSession('communityToken');
      delSession('communityUser');
      state.token = null;
      state.userInfo = {};
      state.menuList = null;
    },
    // 添加tab
    ADD_TAB(state, data) {
      let flag = true;
      for (let item of state.options) {
        if (item.path === data.path) {
          flag = false;
          return;
        }
      }
      if (flag) {
        state.options.push(data);
      }
    },
    // 删除所有tab
    DEL_TABS(state) {
      state.options.splice(1, state.options.length - 1)
    },
    // 删除tab
    DEL_TAB(state, index) {
      state.options.splice(index, 1)
    },
    // 删除左侧tab
    DEL_LEFT_TAB(state, index) {
      state.options.splice(1, index - 1);
    },
    // 删除右侧tab
    DEL_RIGHT_TAB(state, index) {
      state.options.splice(index + 1, state.options.length - index);
    },
    // 删除其他tab
    DEL_OTHER_TAB(state, index) {
      state.options.splice(1, index - 1);
      state.options.splice(2, state.options.length - 2);
    },
    // 设置当前激活的tab
    SET_ACTIVE_INDEX(state, index) {
      this.state.activeIndex = index;
    },

    SET_ACTIVE_PATH(state, path) {
      for (let index in state.options) {
        if (state.options[index].path === path) {
          this.state.activeIndex = index;
        }
      }
    },

    // -----------------推送-----------------------------
    // 推送的文章列表
    SET_SEND_LIST(state, data) {
      this.state[data.name].push(data.item);
      setSession(data.name, this.state[data.name]);
    },
    // 改变文章的顺序
    CHANGE_ARTICLE_SORT(state, data) {
      let sendData = state[data.name];
      let temp = sendData[data.index - 1];
      sendData[data.index - 1] = sendData[data.index]
      sendData[data.index] = temp;
      state[data.name] = [...sendData];
      setSession(data.name, this.state[data.name]);
    },
    // 删除要发送的文章
    DEL_ARTICLE(state, data) {
      state[data.name].splice(data.index, 1);
      setSession(data.name, this.state[data.name]);
    },
    DEL_ALL_ARTICLES(state, name) {
      state[name] = [];
      setSession(name, this.state[name]);
    },


    // 将用户信息存入vuex和session中
    SET_COMMUNITY(state, data) {
      state.communityInfo = data;
      setSession('communityInfo', JSON.stringify(data));
    },
    DEL_COMMUNITY(state) {
      state.communityInfo = {};
      setSession('communityInfo', JSON.stringify(data));
    },

    // 存储需要刷新的iframepath
    SET_REFRESH_PATH(state,path){
      state.refreshPath=path;
    }
  },
  actions: {

  }
})
